<swiper-container
    class="swiper-container"
    [loop]="false"
    [autoplay]="{ delay: 3000 }"
    [followFinger]="true"
    navigation="true"
  >
    <swiper-slide *ngFor="let img of images"
    class="swiper-slide"

    >
      <div 
        class="slide" 
        [ngStyle]="{ 'background-image': 'url(' + img + ')' }">
      </div>
    </swiper-slide>
  </swiper-container>